(module =>{
    module.component('modalConfirm', {
        template: require('./modalConfirm.html'),
        bindings:{
            resolve: '<',
            close: '&',
            dismiss: '&'
        },
        controller: [function(this: $TSFixMe) {
            var $ctrl = this;

            $ctrl.$onInit = () => {
                $ctrl.title = $ctrl.resolve.title;
                $ctrl.text = $ctrl.resolve.text;
                $ctrl.okText = $ctrl.resolve.okText;
                $ctrl.cancelText = $ctrl.resolve.cancelText;
                $ctrl.mode = $ctrl.resolve.mode;
                $ctrl.btnMode = $ctrl.resolve.mode === 'info' ? 'primary' : $ctrl.resolve.mode;
            };

            $ctrl.ok = function () {
                $ctrl.close({});
            };

            $ctrl.cancel = function () {
                $ctrl.dismiss({ $value: 'cancel' });
            };
        }]
    });



})(angular.module('topline.modules'));